<div class="d-flex-end">
  <div *ngIf="showCard" class="cards">
    <i class="icon-spacing" *ngIf="success; else error">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g id="ic-ok" transform="translate(0 -12)">
          <g id="ok" transform="translate(0 12)">
            <g id="Oval_55" data-name="Oval 55">
              <g id="Oval_55-2" data-name="Oval 55" fill="#004A63" stroke="#004A63" stroke-miterlimit="10"
                stroke-width="2">
                <circle cx="30" cy="30" r="30" stroke="none" />
                <circle cx="30" cy="30" r="29" fill="none" />
              </g>
              <circle id="Oval_55-3" data-name="Oval 55" cx="30" cy="30" r="30" fill="none" />
            </g>
            <path id="Path_3" data-name="Path 3" d="M0,10.672l6.621,6.4L24.178,0" transform="translate(18.622 21.889)"
              fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
              stroke-width="4" />
          </g>
        </g>
      </svg>
    </i>
    <ng-template #error>
      <i _ngcontent-wsp-c4="" class="icon-spacing" style="
        width: 60px;
        height: 60px;
        background-color: #FFFFFF;
        border-radius: 50%;
        line-height: 60px;
        text-align: center;
        border: 5px solid #F40000;
        line-height: 50px;
        ">
        <svg xmlns="http://www.w3.org/2000/svg" width="17.657" height="17.657" viewBox="0 0 17.657 17.657">
          <g id="Group_11535" data-name="Group 11535" transform="translate(-5694.015 -487.515)">
            <g id="Group_10713" data-name="Group 10713" transform="translate(24.54 2.54)">
              <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)"
                fill="none" stroke="#F40000" stroke-linecap="round" stroke-width="4"></line>
              <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)"
                fill="none" stroke="#F40000" stroke-linecap="round" stroke-width="4"></line>
            </g>
          </g>
        </svg>
      </i>
    </ng-template>

    <h2 class="title-spacing title">{{ titleMessage }}</h2>
    <p class="title-spacing text-detail">
      {{ messageDesc }}
    </p>
    <div class="button-container" *ngIf="!success">
      <button type="button" class="btn-link"  clickable (click)="gotoContactUs()">Contact us</button>
    </div>
    <button class="btn-secondary btn-spacing"  clickable (click)="continue()">
      {{ btnTitle }}
    </button>
  </div>
</div>